import { render, staticRenderFns } from "./AscLabel.vue?vue&type=template&id=39fb84c6&scoped=true&"
import script from "./AscLabel.vue?vue&type=script&lang=js&"
export * from "./AscLabel.vue?vue&type=script&lang=js&"
import style0 from "./AscLabel.vue?vue&type=style&index=0&id=39fb84c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fb84c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
